module.exports = __webpack_public_path__ + "static/media/placeholder1.6a9d678d.png";